export const setUserDisplayMessage = (error, userMessage) => {
    error.userDisplayMessage = userMessage;
    return error;
};

const throwUserDisplayError = (userMessage, error = userMessage) => {
    const err = new Error(error);

    setUserDisplayMessage(err, userMessage);

    throw err;
};

export default throwUserDisplayError;
